
import BaseModel from './BaseModel';
export default class Amenity extends BaseModel {
    constructor(data = {}) {
        super(data)
        this.setData(data);
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.name = this.translate.name || undefined;
        this.description = this.translate.description || undefined;
        this.url = data.url || undefined;
        this.code = data.code || undefined;
        this.refId = data.refId || undefined;
        this.isActive = data.isActive || false;
        this.isDefault = data.isDefault || false;
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            name: this.name,
            description: this.description,
            url: this.url,
            code: this.code,
            isActive: this.isActive,
            isDefault: this.isDefault,
        });
        if (hasTranslate) result.translate = () => {
            return {
                // id: this.translate.id,
                amenityId: this.translate.amenityId || this.id,
                name: this.name,
                description: this.description,
                languageCode: this.languageCode,
            }
        }
        return result;
    }
}
